import { z } from 'zod';
export const processBugReportJobSchema = z.object({
    reportId: z.string().uuid(),
    clientId: z.string().uuid(),
});
export const retryNotificationJobSchema = z.object({
    reportId: z.string().uuid(),
    clientId: z.string().uuid(),
    integrationType: z.enum(['GITLAB', 'TELEGRAM', 'SLACK']),
    attempt: z.number().int().min(1).max(5),
});
export const cleanupReportsJobSchema = z.object({
    olderThanDays: z.number().int().min(1),
    batchSize: z.number().int().min(1).max(1000).default(100),
});
//# sourceMappingURL=jobs.js.map